/**
 * 首页模块：轮播图、分类入口、精选资源、学习路径与账户入口。
 *
 * 页面只消费公开只读端点，匿名可读；个人学习数据由资源详情与「我的学习」承担。
 */

import { LayoutGrid } from '@lucide/vue'
import type { PortalModule } from '@/shell/module-registry'

const basePath = '/overview'

export const overviewModule: PortalModule = {
  key: 'overview',
  title: '首页',
  icon: LayoutGrid,
  basePath,
  order: 10,
  defaultPath: basePath,
  nav: [{ label: '首页', to: basePath, exact: true }],
  routes: [
    {
      path: '',
      name: 'overview-home',
      component: () => import('./pages/OverviewHome.vue'),
    },
  ],
}
